/**
* Click to Play JS
* -----------------------------------------------------------------------------
*
* All the JS for the Click to Play component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'click-to-play',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const svg = $( '.click-to-play__btn-circle circle' );
      if ( window.hasMotion ) {
        if ( svg !== 0 ) {
          $( svg ).each( function( index, element ) {
            const tl = gsap.timeline( {paused: true} )
                .set( element, {autoAlpha: 1} )
                .from( element, {drawSVG: 0, ease: 'none'} );

            element.onmouseenter = () => tl.play();
            element.onmouseleave = () => tl.reverse();
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
